
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOffIec as ObiOffIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-off-iec.js';
 
 
 

 
 export const ObiOffIec = createComponent({
   react: React,
   tagName: 'obi-off-iec',
   elementClass: ObiOffIecElement,
   events: {
     
   }
  });
 
 